import { Component, inject  } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  private router = inject(Router);

  ngOnInit(): void {
    this.router.navigateByUrl('/rifas/gerenciar');
  }
}
